package device

import api.KioskLayoutType
import apps.App
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import ksp.resource.ResClass
import ksp.resource.ResImage
import ksp.resource.ResRoot
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds

@ResRoot("DeviceApps")
@Serializable
data class DeviceApps(
    @ResClass(Item::class, true, false)
    val items: MutableList<Item> = mutableListOf(),
    @ResClass(KioskBranding::class, false, false)
    val branding: KioskBranding = KioskBranding(),
    @ResClass(CampaignItems::class, true, false)
    val campaignItems: MutableList<CampaignItems> = mutableListOf()
) {

    @Serializable
    data class CampaignItems(
        var id: Long,
        var type: Int,
        var appVariantId: Long,
        @ResClass(App::class, false, true)
        var content: App,
    )

    @Serializable
    data class Item(
        @ResImage(false)
        var logo: Long,
        @ResClass(App::class, false, true)
        var content: App,

        var id: Long,
        var appVariantId: Long,
        var name: String,
        var type: Int,
        var note: String,
        var start: LocalDate,
        var end: LocalDate,
        var scheduled: Boolean,
        var position: Int,
    )

    @Serializable
    data class KioskBranding(
        @ResImage(false)
        var logo: Long = 0L,
        @ResImage(false)
        var overlay: Long = -11L,
        @ResImage(true)
        var images: MutableList<Long> = mutableListOf(),

        var name: String = "Kiosk",
        var colors: Colors = Colors(),
        var timeout: Timeout = Timeout(),
        var text: Text = Text(),
        var sizes: Sizes = Sizes(),
        var params: Params = Params(),
        var layout: Layout = Layout(),
    ) {

        @Serializable
        data class Params(
            var slideshowCropImages: Boolean = true
        )

        @Serializable
        data class Layout(
            /**
             * @see KioskLayoutType
             */
            var type: Int = KioskLayoutType.STANDARD.mask
        )

        @Serializable
        data class Sizes(
            var dashboardIconScale: Int = 60
        )

        @Serializable
        data class Text(
            var closeWarningTitle: String = "",
            var closeWarningDesc: String = "",
            var closeWarningAction: String = "",
        )

        @Serializable
        data class Timeout(
            var handicap: Long = 1.minutes.inWholeMilliseconds,
            var dialog: Long = 10.seconds.inWholeMilliseconds,
            var screen: Long = 1.minutes.inWholeMilliseconds,
        )
    }

    @Serializable
    data class Colors(
        var background: Long = 0xFFffFFff,
        var onBackground: Long = 0xFF1D1B1D,

        var primary: Long = 0xFFEADDFF,
        var onPrimary: Long = 0xFF49454F,

        var secondary: Long = 0xFF6750A4,
        var onSecondary: Long = 0xFFffFFff,

        var primaryContainer: Long = 0xFFffFFff,
        var onPrimaryContainer: Long = 0xFF1D1B1D,

        var secondaryContainer: Long = 0xFFFEF7FF,
        var onSecondaryContainer: Long = 0xFF49454F,
    )
}
